import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["functionalareaSelect", "positioncategorySelect", "tagSelect"]

  // Füge diese Methode hinzu:
  clearEmptyParams(event) {
    const inputs = this.element.querySelectorAll("input, select")
    inputs.forEach(input => {
      if (input.value === "") {
        input.disabled = true
      }
    })
  }

  changeFunctionalarea(event) {
    const functionalareaId = event.target.value
    if (!functionalareaId) return this.clearOptions()

    fetch(`/functionalareas/${functionalareaId}/dependent_options`)
      .then(response => response.json())
      .then(data => {
        this.updateSelect(this.positioncategorySelectTarget, data.positioncategories)
        this.updateSelect(this.tagSelectTarget, data.tags)
      })
  }

  updateSelect(selectElement, items) {
    selectElement.innerHTML = ""
    // optional: Standard-Prompt
    const promptOption = document.createElement("option")
    promptOption.value = ""
    promptOption.textContent = selectElement.dataset.prompt || "Bitte wählen"
    selectElement.appendChild(promptOption)

    items.forEach(item => {
      const option = document.createElement("option")
      option.value = item.id
      option.textContent = item.label
      selectElement.appendChild(option)
    })
  }

  clearOptions() {
    this.updateSelect(this.positioncategorySelectTarget, [])
    this.updateSelect(this.tagSelectTarget, [])
  }
}